// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EditEntity from 'app/components/CRUD/EditEntity';

import {
  CONFIG_PATHS,
  CONFIG_ROUTES,
} from 'app/configuration/configuration-api';

/** Same limits as the add form — see public.fare_media_issuers column widths. */
const inputs = [
  {
    name: 'en_issuer_name',
    labelKey: 'NameEnglish',
    type: 'text',
    required: true,
    maxLength: 45,
  },
  {
    name: 'ar_issuer_name',
    labelKey: 'NameArabic',
    type: 'text',
    required: true,
    maxLength: 45,
  },
  { name: 'phone', labelKey: 'Phone', type: 'text', maxLength: 45 },
  { name: 'email', labelKey: 'Email', type: 'text', maxLength: 45 },
  { name: 'address', labelKey: 'Address', type: 'text', maxLength: 255 },
];

const UpdateFareMediaIssuer: React.FC = () => {
  /**
   * Every field is sent on every save, including the optional ones as "" when
   * cleared — the API reads an empty string on address/phone/email as "set this
   * column back to NULL", which is how a value gets removed.
   */
  const buildUpdatePayload = formValues => ({
    en_issuer_name: formValues.en_issuer_name,
    ar_issuer_name: formValues.ar_issuer_name,
    phone: (formValues.phone || '').trim(),
    email: (formValues.email || '').trim(),
    address: (formValues.address || '').trim(),
  });

  return (
    <EditEntity
      pageTitle="EditFareMediaIssuer"
      fetchApiUrl={CONFIG_PATHS.fareMediaIssuerById}
      fetchApiMethod="GET"
      dataPath="data.data"
      inputs={inputs}
      dropdowns={[]}
      buildUpdatePayload={buildUpdatePayload}
      updateApiUrl={CONFIG_PATHS.fareMediaIssuerById}
      updateApiMethod="PATCH"
      successMessage="FareMediaIssuerUpdatedSuccessfully"
      // EditEntity redirects to backUrl on save (there is no separate
      // successUrl prop), so this lands on the issuer's detail page. Cancel
      // pops one segment back to the list unless came_from=one.
      backUrl={`${CONFIG_ROUTES.fareMediaIssuers}/:id`}
      subsystemName="FareMediaIssuers"
      permissionSystem="masterConfig"
    />
  );
};

export default UpdateFareMediaIssuer;
